export default "__VITE_PUBLIC_ASSET__ef9e5a54__"